import React from 'react'
import { useForm } from 'react-hook-form'
import {
  Button,
  Dropdown,
  FieldGroup,
  Fields,
  Header,
  Input,
  Label,
  StateLabel,
} from '@pet-notify/ui'

import { canadianProvinces, countries, usStates } from '@pet-notify/data'
import { ShippingInput } from 'services/orders'

type Props = {
  state?: Partial<ShippingInput>
  onComplete: (values: ShippingInput) => void
}

function ShippingPage({ state, onComplete }: Props) {
  const { register, handleSubmit, watch } = useForm<ShippingInput>({
    defaultValues: state || {
      country: 'US',
    },
  })
  const country = watch('country')

  return (
    <>
      <Header mb='4' size='xlarge'>
        Shipping address
      </Header>
      <form onSubmit={handleSubmit(onComplete)}>
        <Fields>
          <FieldGroup>
            <Label htmlFor='address-address'>Address</Label>
            <Input id='address-address' {...register('address')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor='address-address2'>Apartment / Suite</Label>
            <Input id='address-address2' {...register('address2')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor='address-city'>City</Label>
            <Input id='address-city' {...register('city')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor='address-country'>Country</Label>
            <Dropdown
              options={countries}
              id='address-country'
              {...register('country')}
            />
          </FieldGroup>
          <FieldGroup>
            <StateLabel htmlFor='address-state' country={country} />
            <Dropdown
              options={country === 'US' ? usStates : canadianProvinces}
              id='address-state'
              {...register('state')}
            />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor='address-zip'>
              {country === 'US' ? `Zip` : `Postal Code`}
            </Label>
            <Input type='text' id='address-zip' {...register('zip')} />
          </FieldGroup>
          <FieldGroup>
            <Label htmlFor='address-phone'>Mobile phone</Label>
            <Input type='phone' id='address-phone' {...register('phone')} />
          </FieldGroup>
        </Fields>
        <Button type='submit'>Save and checkout</Button>
      </form>
    </>
  )
}

export default ShippingPage
